<template>
  <div>
    <div class="text-u-c header-name">Recently Updated</div>
    <div class="viewAll" @click="viewAll()">view all</div>
    <div class="row" v-for="(profile, index) of profiles" :key="index">
      <div class="col-lg-12 p-y b-light profile-block" @click="goOwner(profile.id)">
        <span class="pull-left thumb m-r-xs">
          <lazy-img-loader
            :mainImg="getCompanyImage(profile.profile)"
            :imgAlt="profile.name"
          ></lazy-img-loader>
          <i class="on b-white bottom"></i>
        </span>
        <div class="profile-content">
          <div class="profile-name">{{profile.name}}</div>
          <div class="profile-ago">{{getAgo(profile.profile.updated_at)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import ApiService from "../../../../services/ApiService";
import LazyImgLoader from '@src/components/lazy-img-loader'

export default {
  components: {LazyImgLoader},
  data() {
    return {
      loader: false,
      apiService: new ApiService(),
      profiles: null,
      pageCount: 0,
      perPage: 6,
      page: 1,
      community: window.user.community_id
    };
  },
  created() {
    moment.updateLocale("en", {
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "%ds",
        m: "1m",
        mm: "%dm",
        h: "1h",
        hh: "%dh",
        d: "1d",
        dd: "%dd",
        M: "1 month",
        MM: "%d months",
        y: "1 year",
        yy: "%d years"
      }
    });
    this.getProfiles();
  },
  methods: {
    getProfiles() {
      this.loader = true;
      this.apiService
        .get(
          `/corporate?expand=industry&page=${this.page}&per-page=${this.perPage}&community=${this.community}`
        )
        .then(res => {
          this.profiles = res.items;
          this.pageCount = res._meta.pageCount;
          this.loader = false;
        });
    },
    getCompanyImage(profile) {
      return typeof profile.thumbs['thumb-lg'] !== 'undefined'
        ? profile.thumbs['thumb-lg']
        : profile.avatar
    },
    getAgo(time) {
      return moment.unix(time).fromNow();
    },
    goOwner(id) {
      window.location.assign(
        `${window.user.community_url}/${window.user.community_domain}/default/corporate#/view/${id}/about`
      );
    },
    viewAll() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.header-name {
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 23px;
  color: #000000;
}
.image-rounded {
  border-radius: 100%;
  overflow: hidden;
  margin-right: 10px;
}
.profile-block {
  cursor: pointer;
}
.profile-content {
  padding-top: 7px;
}
.profile-name {
  font-weight: 300;
  font-size: 17px;
  line-height: 20px;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.profile-ago {
  font-weight: normal;
  font-size: 11px;
  line-height: 13px;
  color: #888888;
}
.viewAll {
  cursor: pointer;
  font-size: 12px;
  line-height: 14px;
  color: #555;
}
</style>
